module.exports = __webpack_public_path__ + "img/Nigeria.7c0f2b1c.gif";